import { Avatar } from "@mui/material";
import { useBlogCardWebContext } from "./BlogCardWebProvider";
import useImageSize from "../../../../hooks/global/useImageSize";

export const BlogCardWebCoachProfileImg = () => {
  const { state } = useBlogCardWebContext();
  const [imageUrl] = useImageSize({
    imageUrl: state.blog.user.avatarUrl,
    size: 300,
    isProfile: true,
  });

  return (
    <Avatar
      src={imageUrl}
      alt={state.blog.user.name}
      title={state.blog.user.name}
    >
      {state.blog.user.name[0]}
    </Avatar>
  );
};
